import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import classes from './index.module.scss'
import { ViewNumberOfCompany } from './ViewNumberOfCompany'
import { ViewSort } from './ViewSort'

export const ViewOption = () => {
  return (
    <Element
      className={classes.viewOptions}
      style={{ backgroundColor: '#F9F9F9' }}
    >
      <table>
        <tbody>
          <tr>
            <td>
              <Element className={`${classes.minW50} ${classes.pt6} fw600`}>
                <Translate value="screening.VIEW_COUNT" />
                &nbsp;
                <Element elementName="span" style={{ color: '#E0505B' }}>
                  *
                </Element>
              </Element>
            </td>
            <td>
              <ViewNumberOfCompany />
            </td>
          </tr>
          <tr>
            <td>
              <Element className={`${classes.pt6} fw600`}>
                <Translate value="screening.SORT_BY" />
              </Element>
            </td>
            <td>
              <ViewSort />
            </td>
          </tr>
        </tbody>
      </table>
    </Element>
  )
}
